import React from 'react';
import { motion } from 'framer-motion';
import {  FaPhone, FaEnvelope } from 'react-icons/fa';
//import {FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaMapMarkerAlt} from 'react-icons/fa';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-gray-800">
      <div className="container mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="mb-6 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="mb-4">
                <motion.img 
                  src={logo}
                  alt="JDP Finance Logo" 
                  className="h-20 md:h-24"
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 300 }}
                />
              </div>
              <p className="text-sm md:text-base mb-4 text-gray-600">
                We provide personal loans designed to help you meet your financial needs with flexible terms and competitive rates.
              </p>
              {/* <div className="flex space-x-3 mt-4">
                <a href="#" className="bg-blue-100 hover:bg-green-100 text-blue-900 hover:text-green-600 p-2 rounded-full transition duration-300">
                  <FaFacebookF />
                </a>
                <a href="#" className="bg-blue-100 hover:bg-green-100 text-blue-900 hover:text-green-600 p-2 rounded-full transition duration-300">
                  <FaTwitter />
                </a>
                <a href="#" className="bg-blue-100 hover:bg-green-100 text-blue-900 hover:text-green-600 p-2 rounded-full transition duration-300">
                  <FaInstagram />
                </a>
                <a href="#" className="bg-blue-100 hover:bg-green-100 text-blue-900 hover:text-green-600 p-2 rounded-full transition duration-300">
                  <FaLinkedinIn />
                </a>
              </div> */}
            </motion.div>
          </div>

          {/* Quick Links */}
          <div className="mb-6 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1, duration: 0.5 }}
            >
              <h3 className="text-lg font-semibold mb-4 border-b border-green-500 pb-2 inline-block text-blue-900">
                Quick Links
              </h3>
              <ul className="space-y-2">
                <li>
                  <a href="/" className="text-gray-600 hover:text-green-600 transition duration-300">Home</a>
                </li>
                <li>
                  <a href="/apply-now" className="text-gray-600 hover:text-green-600 transition duration-300">Apply Now</a>
                </li>
                <li>
                  <a href="/costs" className="text-gray-600 hover:text-green-600 transition duration-300">Costs</a>
                </li>
                <li>
                  <a href="/contact-us" className="text-gray-600 hover:text-green-600 transition duration-300">Contact Us</a>
                </li> 
              </ul>
            </motion.div>
          </div>

          {/* Legal */}
          <div className="mb-6 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <h3 className="text-lg font-semibold mb-4 border-b border-green-500 pb-2 inline-block text-blue-900">
                Legal
              </h3>
              <ul className="space-y-2">
                <li>
                  <a href="/legal/privacy-statement" className="text-gray-600 hover:text-green-600 transition duration-300">
                    {/*Your Privacy and the Provision Of Credit*/}
                    Privacy Statement
                  </a>
                </li>
                <li>
                  <a href="/legal/credit-information" className="text-gray-600 hover:text-green-600 transition duration-300">
                    {/* Credit Information Privacy Management Policy */}
                    Credit Reporting Statement
                  </a>
                </li>
                <li>
                  <a href="/legal/credit-guides" className="text-gray-600 hover:text-green-600 transition duration-300">
                    Credit Guides
                  </a>
                </li>
                <li>
                  <a href="/legal/complaints" className="text-gray-600 hover:text-green-600 transition duration-300">
                    {/* Complaints */}
                    Complaints Management Policy
                  </a>
                </li>
{/*                 <li>
                  <a href="/legal/website-privacy" className="text-gray-600 hover:text-green-600 transition duration-300">
                    Website Privacy Policy
                  </a>
                </li> */}
                <li>
                  <a href="/legal/disclaimer" className="text-gray-600 hover:text-green-600 transition duration-300">
                    Disclaimer
                  </a>
                </li>
                <li>
                  <a href="/legal/target-market" className="text-gray-600 hover:text-green-600 transition duration-300">
                    Target Market Determination
                  </a>
                </li>
              </ul>
            </motion.div>
          </div>

          {/* Contact Us */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <h3 className="text-lg font-semibold mb-4 border-b border-green-500 pb-2 inline-block text-blue-900">
                Contact Us
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <FaPhone className="text-green-600 mr-3 mt-1" />
                  <div>
                    <p className="font-medium text-blue-900">Phone</p>
                    <a href="tel:0425625605" className="text-gray-600 hover:text-green-600 transition duration-300">0425 625 605</a>
                  </div>
                </li>
                <li className="flex items-start">
                  <FaEnvelope className="text-green-600 mr-3 mt-1" />
                  <div>
                    <p className="font-medium text-blue-900">Email</p>
                    <a href="mailto:contact@jdpfinance.com.au" className="text-gray-600 hover:text-green-600 transition-colors duration-300 text-sm md:text-base break-all">contact@jdpfinance.com.au</a>
                  </div>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>

        {/* Newsletter Subscription - Responsive */}
        {/* <div className="mt-12 mb-8">
          <div className="bg-blue-50 rounded-lg p-6 md:p-8 max-w-4xl mx-auto shadow-sm border border-blue-100">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              <div className="text-center mb-6">
                <h3 className="text-xl md:text-2xl font-bold mb-2 text-blue-900">Subscribe to Our Newsletter</h3>
                <p className="text-sm md:text-base text-gray-600">Stay updated with our latest offers, news, and financial tips</p>
              </div>
              
              <div className="flex flex-col sm:flex-row items-center space-y-3 sm:space-y-0 sm:space-x-2">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="w-full px-4 py-3 rounded-lg bg-white text-gray-700 placeholder-gray-500 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                <button className="w-full sm:w-auto px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition duration-300 whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </motion.div>
          </div>
        </div> */}

        {/* Copyright */}
        <div className="border-t border-gray-200 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-center md:text-left mb-4 md:mb-0 text-gray-600">
              © {new Date().getFullYear()} Authorized Credit Representative (No. 569556) for Strawberry Loans (Australian Credit Licence Number 519253)
            </p>
            {/* <div className="flex space-x-4 text-sm">
              <a href="/privacy-policy" className="text-gray-600 hover:text-green-600 transition duration-300">Privacy Policy</a>
              <a href="/terms-of-service" className="text-gray-600 hover:text-green-600 transition duration-300">Terms of Service</a>
              <a href="/cookie-policy" className="text-gray-600 hover:text-green-600 transition duration-300">Cookie Policy</a>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;